import { PREVIEW_MOCK_DATA, isPreviewMode } from '../../utils/previewMode';
import { graphQLQuery } from '../api/ApiClient';
import { bookingTerms } from '../graphql/queries';
import { makeApiAction } from './shared/helpers';

export const fetchBookingTermsAction = (areaId, date, time, size) => async (dispatch) => {
  if (isPreviewMode()) {
    dispatch({ type: 'FETCH_BOOKING_TERMS_SUCCESS', payload: PREVIEW_MOCK_DATA.bookingTerms });
    return;
  }

  const request = (variables) => graphQLQuery(bookingTerms, variables);
  makeApiAction(
    'FETCH_BOOKING_TERMS',
    request,
    { areaId, date, time, size },
    'bookingTerms',
    null,
    dispatch,
    null,
    null,
    false,
    true,
  );
};
